module.exports = __webpack_public_path__ + "assets/1ac26ed4d2741875e642abb0725bfd21.svg";